/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import $ from 'jquery';
import _ from 'underscore';
import request from 'js-sdk/src/common/transport/request';
import base64 from "js-sdk/src/common/util/base64";
import dashboardSettings from '../dashboardSettings';

var _oldStyle;
var currentViewerView;

function setRequiredByPhantomPrefixes(view) {
    view.$('.jrPage').each(function (index, element) {
        var $element = $(element), elementStyle = $element.attr('style') || '', transform = $element.css('transform'),
            transformOrigin = $element.css('transform-origin');
        if (elementStyle.indexOf('transform') >= 0 && elementStyle.indexOf('-webkit-transform') === -1) {
            $element.attr('style', [
                elementStyle,
                '-webkit-transform:',
                transform,
                '; -webkit-transform-origin:',
                transformOrigin,
                ';'
            ].join(''));
        }
    });
}

function embedImages() {
    try {
        var canvas = document.createElement("canvas"),
            dfd = new $.Deferred();

        if (!canvas || !canvas.getContext) {
            dfd.resolve();
        } else {
            return $.when.apply($, $("img").map(function (index, img) {
                var mapResultDfd = new $.Deferred();
                if (img.src.substring(0, 4) !== "data") {
                    if (!canvas) {
                        canvas = document.createElement("canvas");
                    }

                    try {
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;

                        canvas.getContext("2d").drawImage(img, 0, 0);

                        img.src = canvas.toDataURL("image/png");

                        mapResultDfd.resolve();
                    } catch (e) {
                        const imageUrl = img.src;
                        if (imageUrl.indexOf('/rest_v2/') >= 0) {
                            const downloadedImg = new Image();
                            downloadedImg.crossOrigin = "use-credentials";
                            downloadedImg.addEventListener("load", () => {
                                canvas = document.createElement("canvas");

                                canvas.width = downloadedImg.width;
                                canvas.height = downloadedImg.height;

                                canvas.getContext("2d").drawImage(downloadedImg, 0, 0);

                                try {
                                    img.src = canvas.toDataURL("image/png");
                                    mapResultDfd.resolve();
                                } catch (err) {
                                    mapResultDfd.resolve();
                                }
                            }, false);

                            downloadedImg.src = imageUrl;
                        } else {
                            mapResultDfd.resolve();
                        }
                    }
                    canvas = null;
                } else {
                    mapResultDfd.resolve();
                }
                return mapResultDfd.promise();
            }));
        }
    } catch (e) {
    }

    return dfd.promise();
}

function embedValues() {
    $("input").each(function (index, inp) {
        var input = $(inp),
            type = input.attr("type");

        if (type == "text") {
            input.attr("value", input.val());
        } else if (type == "radio" || type == "checkbox") {
            input.attr("checked", inp.checked ? "checked" : null);
        }
    });
}

function style() {
    return _.reduce(document.styleSheets, function (memo, stylesheet) {
        var reportResourcePrefix = "/reportresource?",
            restResourcePrefix = "/rest_v2/resources",
            index = stylesheet.href ? stylesheet.href.indexOf(reportResourcePrefix) : -1;
        if (index >= 0) {
            memo.push(stylesheet.href.substring(index));
        } else {
            index = stylesheet.href ? stylesheet.href.indexOf(restResourcePrefix) : -1;
            if (index >= 0) {
                memo.push('data:text/css;base64,' + base64.encode(stylesheetString(stylesheet)));
            }
        }
        return memo;
    }, []);
}

function stylesheetString(stylesheet) {
    return Array.from(stylesheet.cssRules).reduce((cssString, rule) => cssString + rule.cssText + '\n', '');
}

function hideJive() {
    var jive_overlay = $("#jive_overlay").css("display"),
        jive_marker = $("#jive_marker").css("display"),
        jive_foobar = $("#jive_marker").css("display");

    $("#jive_overlay").css("display", "none");
    $("#jive_marker").css("display", "none");
    $("#jive_foobar").css("display", "none");

    return function () {
        $("#jive_overlay").css("display", jive_overlay);
        $("#jive_marker").css("display", jive_marker);
        $("#jive_foobar").css("display", jive_foobar);
    }
}

export default {
    registerCurrentViewer: function(view){
        currentViewerView = view;
    },
    prepareForExport: function (canvasView) {
        setRequiredByPhantomPrefixes(canvasView);
    },
    applyReferenceSize: function (canvasView, size) {
        var ratio, canvas = canvasView.$('.dashboardCanvas:first').length == 0 ? canvasView.$el : canvasView.$('.dashboardCanvas:first');
        _oldStyle = _oldStyle || canvas.attr('style') || false;
        ratio = Math.min(3508 / size.width, 2480 / size.height);
        // style set using attribute intentionally, because -webkit-* properties are removed sometimes,
        // while old PhantomJS versions demand exactly -webkit-* versions of selector names
        // style set using attribute intentionally, because -webkit-* properties are removed sometimes,
        // while old PhantomJS versions demand exactly -webkit-* versions of selector names
        canvas.attr('style', '-webkit-transform: scale(' + ratio + '); transform-origin: left top; transform: scale(' + ratio + '); -webkit-transform-origin: left top; width: ' + size.width + 'px; height: ' + size.height + 'px;');
    },
    removeReferenceSize: function (canvasView) {
        var canvas = canvasView.$('.dashboardCanvas:first').length == 0 ? canvasView.$el : canvasView.$('.dashboardCanvas:first');
        if (!_.isUndefined(_oldStyle)) {
            canvas.attr('style', _oldStyle ? _oldStyle : null);
            _oldStyle = undefined;
        }
    },
    requestDashboardExport: function (self, options) {
        self = self || currentViewerView;

        var contextPath = self.contextPath;
        var dfd = new $.Deferred();

        var dtoDfd;
        if (options.detailed) {
            dtoDfd = this.createDetailedExportDto(self, options.outputFormat, options.includeDashletIds);
        } else {
            dtoDfd = this.createScreenshotExportDto(self, options.outputFormat);
        }
        dtoDfd.then((dto) => {
            request({
                url: contextPath + "/rest_v2/dashboardExecutions",
                method: "POST",
                headers: {
                    "Accept": "application/json",
                },
                contentType: "application/json",
                processData: false,
                dataType: "json",
                data: JSON.stringify(dto)
            }).done((a, b, c) => { dfd.resolve(a, b, c) }).fail((a, b, c) => { dfd.reject(a, b, c) })
        });

        return dfd;
    },
    createScreenshotExportDto: function createScreenshotExportDto(self, type) {
        var markup, width, height, content,
            restoreJive = hideJive(),
            canvas = self.dashboardCanvas ? self.dashboardCanvas.$el : self.$('.dashboardCanvas:first'),
            dfd = new $.Deferred();

        embedImages().then(() => {
            embedValues();
            this.prepareForExport(self.dashboardCanvas ? self.dashboardCanvas : self);

            if (type == "pdf") {
                content = canvas.children(".content");
                this.applyReferenceSize(self.dashboardCanvas ? self.dashboardCanvas : self, {
                    width: content.width(),
                    height: content.height()
                });

                width = 3508;
                height = 2480;
            } else {
                width = canvas.width();
                height = canvas.height();
            }

            markup = canvas.parent().html();

            restoreJive();

            this.removeReferenceSize(self.dashboardCanvas ? self.dashboardCanvas : self);

            dfd.resolve({
                uri: self.model.get("uri"),
                width: width,
                height: height,
                format: type,
                markup: markup,
                jrStyle: style()
            });
        });
        return dfd.promise();
    },
    createDetailedExportDto: function createScreenshotExportDto(self, type, includeDashletIds) {
        var dfd = new $.Deferred(),
            canvasModel = self.canvas ? self.canvas.model : self.model,//use design preview model if present
            components = canvasModel.currentFoundation.components.models,
            params = components.filter(model => model.get('type') === 'inputControl')
                .map(model => ({ name: model.get('id'), value: model.get('value') })),
            runtimeComponents = [],
            dashboardResource = self.model.isDesigner && self._hasUnsavedChanges() ? self.model.toJSON() : null;
        components.forEach(model => {
            var runtimeAttributes = [],
                drillDownParameters;

            if (model.reportExecutionId) {
                runtimeAttributes.push({ componentReportExecution: { reportExecutionId: model.reportExecutionId } });
            }
            if (model.drilldownInfo && model.drilldownInfo.rowFilter) {
                drillDownParameters = model.drilldownInfo.rowFilter.map((rowFilter) => ({
                    field: rowFilter.name,
                    value: rowFilter.value
                }));
            }

            if ((model.get('type') === 'chart' || model.get('type') === 'adhocDataView') && model.updatedChartType) {
                runtimeAttributes.push({ adhocTypeChange: { updatedChartType: model.updatedChartType } });
            }
            if (model.paramsModel && model.paramsModel.keys().length) {
                if (model.paramsModel.get('target') === dashboardSettings.DASHLET_REPLACE_ACTION) {
                    let replaceParameters = model.paramsModel.get('parameters');
                    let parameters = _.keys(replaceParameters).map(param => ({ name: param, value: replaceParameters[param] }));
                    runtimeAttributes.push({ componentReplace: { resource: model.paramsModel.get('resource'), parameters: parameters } });
                } else {
                    let componentParameters = model.paramsModel.keys().map(param => ({ name: param, value: model.paramsModel.get(param) }));
                    runtimeAttributes.push({ componentParameters: { parameters: componentParameters } });
                }
            }
            if (runtimeAttributes.length || drillDownParameters) {
                var runtimeComponent = {
                    componentId: model.get('id')
                }

                runtimeAttributes.length && (runtimeComponent.attributes = runtimeAttributes);
                drillDownParameters && (runtimeComponent.drillDownParameters = drillDownParameters);

                runtimeComponents.push(runtimeComponent);
            }
        });
        dfd.resolve({
            uri: self.model.get("uri"),
            format: type,
            detailed: true,
            includeDashletIds: includeDashletIds,
            parameters: { dashboardParameter: params },
            runtimeComponents: runtimeComponents,
            dashboard: dashboardResource
        });
        return dfd.promise();
    },
    wait: function wait(self, id, dfd) {
        self = self || currentViewerView;
        id && request({
            url: self.contextPath + "/rest_v2/dashboardExecutions/" + id + "/status",
            headers: {
                "Accept": "application/json"
            },
            dataType: "json"
        }).done(function (status) {
            if (status.status === "execution") {
                dfd.notifyWith(self, [status.progress]);
                setTimeout(()=>{
                    wait(self, id, dfd);
                }, 1000);
            } else {
                dfd.resolve({
                    status: status.status,
                    href: self.contextPath + "/rest_v2/dashboardExecutions/" + status.id + "/outputResource",
                    id: status.id
                });
            }
        }).fail(_.bind(dfd.reject, dfd));
        return dfd;
    }

};
